import { Observable } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { TrainingStateGateway } from './training-state-gateway'
import { TrainingModel } from '../models/training-model'
@Injectable()
export class NetworkTrainingStateGateway extends TrainingStateGateway {
    constructor(private http: HttpClient) {
        super()
    }
    // GetUserTrainingDetails(planyear: string, orgid: string, userName: string): Observable<TrainingModel[]> {
    //    return this.http.get<TrainingModel[]>
    //        ('../api/GetUserTrainingDetails?planyear=' + planyear + '&orgid=' + orgid + '&username=' + userName)
    // }

    GetUserTrainingDetails(userProfileID: number, planyear: number): Observable<TrainingModel[]> {
        return this.http.get<TrainingModel[]>(`../api/GetUserTrainingDetailsByCheck/${userProfileID}/${planyear}`)
        // return this.http.get<WebUserComment[]>('../api/getUserComments/' + userProfileID)
    }
}
